(function () {
  var AUTO_LOADS = 0; // auto-loading switched off 2026-10-25 (user): load only on click
  var STATE_TTL = 30 * 60 * 1000;
  var stateKey = 'load-more:' + location.pathname + location.search;
  var loadedPages = [];
  var autoLoads = 0;
  var observer = null;

  function track(name) {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  function wrapper() {
    return document.querySelector('[data-load-more-wrapper]');
  }

  function fetchPage(url, sectionId) {
    var separator = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + separator + 'section_id=' + encodeURIComponent(sectionId)).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    });
  }

  // Appends the products of a fetched page and syncs count, bar and button with it.
  function applyPage(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('#product-grid');
    var currentGrid = document.querySelector('#product-grid');
    if (newGrid && currentGrid) currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);

    var current = wrapper();
    var incoming = doc.querySelector('[data-load-more-wrapper]');
    if (!current || !incoming) return;
    var shown = current.querySelector('[data-load-more-shown]');
    var newShown = incoming.querySelector('[data-load-more-shown]');
    if (shown && newShown) shown.textContent = newShown.textContent;
    var bar = current.querySelector('[data-load-more-bar]');
    var newBar = incoming.querySelector('[data-load-more-bar]');
    if (bar && newBar) bar.style.width = newBar.style.width;

    var button = current.querySelector('[data-load-more-button]');
    var newButton = incoming.querySelector('[data-load-more-button]');
    if (button && newButton) {
      button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
    } else if (button) {
      button.remove();
    }
  }

  // Grows the grid by the rows the next page will fill, right at the tap. The footer then moves while the
  // tap still excuses the shift; if it moved when the products arrive (often >0.5s later on phones) the
  // whole jump would count as layout shift (Clarity showed CLS 0.4-0.8 on collections).
  function reserveSpace(current) {
    var grid = document.querySelector('#product-grid');
    var items = grid ? grid.children : [];
    if (!items.length) return null;
    var shownEl = current.querySelector('[data-load-more-shown]');
    var shown = shownEl ? parseInt(shownEl.textContent, 10) || items.length : items.length;
    var total = parseInt(current.getAttribute('data-total'), 10) || 0;
    var perPage = parseInt(current.getAttribute('data-per-page'), 10) || 24;
    var incoming = total ? Math.min(perPage, total - shown) : perPage;
    if (incoming <= 0) return null;
    var columns = 0;
    while (columns < items.length && items[columns].offsetTop === items[0].offsetTop) columns++;
    var rows = Math.ceil((items.length + incoming) / columns) - Math.ceil(items.length / columns);
    var rowGap = parseFloat(getComputedStyle(grid).rowGap) || 0;
    var rowHeight = items[items.length - 1].offsetHeight + rowGap;
    // Padding, not min-height: the grid is a wrapping flexbox and a min-height would stretch its rows apart.
    grid.style.paddingBottom = rows * rowHeight + 'px';
    return grid;
  }

  function loadNext(source) {
    var current = wrapper();
    var button = current && current.querySelector('[data-load-more-button]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var url = button.getAttribute('data-next-url');
    if (!url) return;

    button.setAttribute('aria-busy', 'true');
    var reserved = reserveSpace(current);
    fetchPage(url, current.getAttribute('data-section-id'))
      .then(function (html) {
        applyPage(html);
        if (reserved) reserved.style.paddingBottom = '';
        loadedPages.push(url);
        track(source === 'auto' ? 'load_more_auto' : 'load_more_click');
      })
      .catch(function () {})
      .then(function () {
        if (reserved) reserved.style.paddingBottom = '';
        var stillThere = wrapper() && wrapper().querySelector('[data-load-more-button]');
        if (stillThere) stillThere.removeAttribute('aria-busy');
        observe();
      });
  }

  // The first AUTO_LOADS pages load on their own when the button comes into view; after that it's a click.
  function observe() {
    if (observer) observer.disconnect();
    if (autoLoads >= AUTO_LOADS || !('IntersectionObserver' in window)) return;
    var button = wrapper() && wrapper().querySelector('[data-load-more-button]');
    if (!button) return;
    observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting || autoLoads >= AUTO_LOADS) return;
        autoLoads++;
        observer.disconnect();
        loadNext('auto');
      },
      { rootMargin: '300px 0px 600px 0px' }
    );
    observer.observe(button);
  }

  // The state is attached to this page's own history entry, so it only comes back when the visitor
  // returns to this exact entry (back button or reload), never on a fresh visit from the menu.
  // sessionStorage is a fallback for browsers that drop history.state.
  function saveState() {
    var state = { pages: loadedPages, scrollY: window.scrollY, auto: autoLoads, time: Date.now() };
    try {
      var entry = history.state && typeof history.state === 'object' ? history.state : {};
      history.replaceState(Object.assign({}, entry, { loadMore: state }), '');
    } catch (e) {}
    try {
      sessionStorage.setItem(stateKey, JSON.stringify(state));
    } catch (e) {}
  }

  function readState() {
    var state = history.state && history.state.loadMore;
    if (!state && isBackNavigation()) {
      try {
        state = JSON.parse(sessionStorage.getItem(stateKey) || 'null');
      } catch (e) {}
    }
    return state && Date.now() - state.time < STATE_TTL ? state : null;
  }

  function navigationType() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav) return nav.type;
    var legacy = performance.navigation && performance.navigation.type;
    return legacy === 2 ? 'back_forward' : legacy === 1 ? 'reload' : 'navigate';
  }

  function isBackNavigation() {
    return navigationType() === 'back_forward';
  }

  function clearState() {
    try {
      if (history.state && history.state.loadMore) {
        var entry = Object.assign({}, history.state);
        delete entry.loadMore;
        history.replaceState(entry, '');
      }
      sessionStorage.removeItem(stateKey);
    } catch (e) {}
  }

  // Coming back from a product page: reload the pages that were open and return to the same spot.
  // Done by hand because some browsers (Safari, in-app browsers) reload the page and land at the top.
  function restore() {
    var state = readState();
    var grid = document.querySelector('#product-grid');
    if (!state || !grid || navigationType() === 'reload') return false;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    // Consume it: if the page dies while rebuilding (low-memory phones), the reload starts clean
    // instead of rebuilding again. It is saved anew when the visitor leaves for a product.
    clearState();
    var sectionId = grid.getAttribute('data-id');
    Promise.all(
      state.pages.map(function (url) {
        return fetchPage(url, sectionId);
      })
    )
      .then(function (pages) {
        pages.forEach(applyPage);
        loadedPages = state.pages.slice();
        autoLoads = state.auto || 0;
        settleScroll(state.scrollY);
        if (pages.length) track('load_more_restore');
      })
      .catch(function () {})
      .then(observe);
    return true;
  }

  // Images and cards can still shift the layout right after the jump, so re-apply it a few times
  // unless the visitor has started scrolling on their own.
  function settleScroll(y) {
    var touched = false;
    var stop = function () { touched = true; };
    window.addEventListener('touchstart', stop, { once: true, passive: true });
    window.addEventListener('wheel', stop, { once: true, passive: true });
    [0, 150, 500, 1200].forEach(function (delay) {
      setTimeout(function () {
        if (!touched && Math.abs(window.scrollY - y) > 20) window.scrollTo(0, y);
      }, delay);
    });
  }

  function init() {
    if (!restore()) observe();

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-load-more-button]')) loadNext('click');
      if (event.target.closest('#product-grid > li')) saveState();
    }, true);
    window.addEventListener('pagehide', saveState);
    window.addEventListener('pageshow', function (event) {
      var state = event.persisted && readState();
      if (state && Math.abs(window.scrollY - state.scrollY) > 100) settleScroll(state.scrollY);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });

    // Filters and sorting re-render the grid: start over for the new result set.
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function () {
        var grid = document.querySelector('#product-grid');
        if (!grid || grid.hasAttribute('data-load-more-seen')) return;
        grid.setAttribute('data-load-more-seen', '');
        loadedPages = [];
        autoLoads = 0;
        observe();
      }).observe(container, { childList: true });
    }
    var grid = document.querySelector('#product-grid');
    if (grid) grid.setAttribute('data-load-more-seen', '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
